import { Vue, Component } from "vue-property-decorator";
import DynPanel from './dyn-panel';
import NotificationStack from './notifications';
import {PortalTarget} from "portal-vue";

@Component
export default class App extends Vue {
  render() {
    return (
      <section class="app">
        <router-view />
        <DynPanel/>
        <PortalTarget name="dropdown" class="dropdown-portal"/>
        <PortalTarget name="lightbox" class="lightbox-portal"/>
        <NotificationStack/>
      </section>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-cd834a1a/app.tsx" });